import { createAuthSession } from '@concours/api-client'

type Listener = (version: number) => void
const permVersionListeners = new Set<Listener>()

/** Notifié quand l'API signale une nouvelle version des permissions (en-tête x-perm-version). */
export function onPermVersion(listener: Listener) {
  permVersionListeners.add(listener)
  return () => {
    permVersionListeners.delete(listener)
  }
}

/**
 * Session du portail admin (ADR-014, ADR-020) : token d'accès en mémoire,
 * rafraîchissement par cookie HttpOnly (12 h), MFA TOTP.
 * Les composants y accèdent via `useAuthSession()` / `useAuth()`.
 */
export const session = createAuthSession({
  portal: 'admin',
  baseUrl: import.meta.env.VITE_API_URL ?? '',
  onPermVersion: (version) => permVersionListeners.forEach((listener) => listener(version)),
})
